import {IntlProvider, addLocaleData,FormattedMessage } from 'react-intl';
import zhCN from './langConfig/zh-CN.js';  //导入 i18n 配置文件,需要手动创建并填入语言转换信息
import enUS from './langConfig/en-US.js';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import React, { Component } from 'react'

addLocaleData([...en, ...zh]);

const langMap = {
    'zh-CN': zhCN,
    'en-US': enUS
};
 const IntlWrap=(WrappedComponent)=> {
    return  class extends Component {
        render() {
            let ret = null;
            let locale=this.props.locale||'zh-CN';
            ret = (<IntlProvider locale={locale} messages={langMap[locale]}>
                <WrappedComponent locale={locale} {...this.props} />
            </IntlProvider>);
            return ret;
        }

    }

}
export default IntlWrap
